"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Modal = function Modal(props) {
  var isOpen = props.isOpen,
      children = props.children,
      onBackgroundClick = props.onBackgroundClick,
      onBackgroundMouseDown = props.onBackgroundMouseDown,
      classNames = props.classNames;
  var backgroundClassNames = {
    open: isOpen,
    closed: !isOpen
  }; // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('modal__background', backgroundClassNames),
    onClick: onBackgroundClick,
    onMouseDown: onBackgroundMouseDown,
    role: "button",
    tabIndex: -1,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('modal__content', classNames),
    role: "presentation",
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    onMouseDown: function onMouseDown(e) {
      e.stopPropagation();
    }
  }, children));
};

exports.Modal = Modal;
Modal.propTypes = {
  onBackgroundClick: _propTypes.default.func.isRequired,
  onBackgroundMouseDown: _propTypes.default.func.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.oneOf([null])]),
  isOpen: _propTypes.default.bool.isRequired,
  classNames: _propTypes.default.any.isRequired
};
var defaultProps = {
  classNames: {},
  onBackgroundClick: function onBackgroundClick() {},
  onBackgroundMouseDown: function onBackgroundMouseDown() {},
  children: null
};
Modal.defaultProps = defaultProps;
var _default = Modal;
exports.default = _default;